import React, { useState, useEffect, useRef } from "react";
import "./Navbar.css";
import logo from "../Images/logo.png";
import tie_logo4 from "../Images/tie_logo4.png";
import { IoIosArrowDown, IoIosArrowUp, IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";
import { IoMenu } from "react-icons/io5";

const Navbar = () => {
  const [isShrunk, setIsShrunk] = useState(false);
  const [isSolutionsDropdownOpen, setSolutionsDropdownOpen] = useState(false);
  const [isResourcesDropdownOpen, setResourcesDropdownOpen] = useState(false);
  const [menu, setMenu] = useState(false)
  const solutionsRef = useRef(null);
  const resourcesRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsShrunk(true);
      } else {
        setIsShrunk(false);
      }
      // setSolutionsDropdownOpen(false);
      // setResourcesDropdownOpen(false);
    };

    const handleClickOutside = (event) => {
      if (
        solutionsRef.current &&
        !solutionsRef.current.contains(event.target)       ) {
        setSolutionsDropdownOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleSolutionsDropdown = () => {
    setSolutionsDropdownOpen(prev => !prev);
  };



  const handleMenu = () => {
    setMenu(prev => !prev)
  }


  return (
    <nav className={`navbar ${isShrunk ? "shrink" : ""}`}>
      <div className="navbar-brand">
        <Link to="/">
        <img src={tie_logo4} alt="Logo" className="logo" />

        </Link>
        <div className="brand-info">
          <span className="navbar-brand-text">Tech It Easy</span>
          <span className="navbar-tagline">Smarter - Simpler - Faster</span>
        </div>
      </div>
      
      <div className="hamburger-menu">
        <IoMenu onClick={handleMenu}/>
      </div>
      <ul className={`navbar-links mobile-nav ${menu && "menu-active"}`} >
      <IoMdClose className="close-menu" onClick={handleMenu}/>
        <li onClick={handleMenu}>
          <Link to="/">Home</Link>
        </li>

        <li
          ref={solutionsRef}
          className={`dropdown ${isSolutionsDropdownOpen ? "active" : ""}`}
        >
          <button onClick={toggleSolutionsDropdown} className="arrowBtn">
            Solutions{" "}
            {isSolutionsDropdownOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </button>
            <ul className="dropdown-menu" onClick={()=>{ toggleSolutionsDropdown(); handleMenu()}}>
              <li className="dropdown-menu-btns">
                <Link to="/saraleway">Saral eWay</Link>
              </li>
              <li className="dropdown-menu-btns">
                <Link to="/saraltransport">Saral Transport</Link>
              </li>
            </ul>
        
        </li>
        <li onClick={handleMenu}>
          <Link to="/services">Services</Link>
        </li>
        <li onClick={handleMenu}>
          <Link to="/hire-dedicated-developers">Hire</Link>
        </li>
        <li onClick={handleMenu}>
          <Link to="/aboutus">About Us</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
